import React from 'react';

import ActivityLogSkeleton from './components/ActivityLogSkeleton';
import CommentSkeleton from './components/CommentSkeleton';

const skeletons = [
  { type: 'activity', key: 'activity-1' },
  { type: 'activity', key: 'activity-2' },
  { type: 'comment', key: 'comment-1' },
  { type: 'comment', key: 'comment-2' },
  { type: 'activity', key: 'activity-3' },
  { type: 'comment', key: 'comment-3' }
];

const ActivitiesLogSkeleton = () => {
  return (
    <div className="flex flex-1 flex-col justify-between gap-5 px-3 pb-3 pt-0">
      <div className="flex flex-col gap-5">
        {skeletons.map((skeleton) =>
          skeleton.type === 'activity' ? (
            <ActivityLogSkeleton key={skeleton.key} />
          ) : (
            <CommentSkeleton key={skeleton.key} />
          )
        )}
      </div>
    </div>
  );
};

export default ActivitiesLogSkeleton;
